import { render, staticRenderFns } from "./CadastroProcedimentos.vue?vue&type=template&id=4ec5d375&"
import script from "./CadastroProcedimentos.vue?vue&type=script&lang=js&"
export * from "./CadastroProcedimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports